import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { BlogService } from '../blog.service';

export const useCreateBlogPost = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (body: Blog.CreateBlogPost) => BlogService.create(body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['blog-posts'] });
			toast.success('Post criado com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro ao criar post'));
		},
	});
};

export const useUpdateBlogPost = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: Blog.UpdateBlogPost }) =>
			BlogService.update(id, body),
		onSuccess: (_, { id }) => {
			queryClient.invalidateQueries({ queryKey: ['blog-posts'] });
			queryClient.invalidateQueries({ queryKey: ['blog-post', id] });
			toast.success('Post atualizado com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro ao atualizar post'));
		},
	});
};

export const useDeleteBlogPost = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => BlogService.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['blog-posts'] });
			toast.success('Post removido com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro ao remover post'));
		},
	});
};
